import { motion } from "framer-motion";
import { Search, CreditCard, PartyPopper } from "lucide-react";

const steps = [
  {
    icon: Search,
    title: "Caută beneficiul dorit",
    text: "Explorează ofertele disponibile pe isic.ro sau în Alive App.",
  },
  {
    icon: CreditCard,
    title: "Prezintă cardul BRD-ISIC",
    text: "La partenerii fizici, prezinți cardul tău BRD-ISIC. Pentru ofertele online, urmezi instrucțiunile din ofertă.",
  },
  {
    icon: PartyPopper,
    title: "Bucură-te de reducere",
    text: "Accesezi rapid beneficiul disponibil și profiți de avantajele cardului tău.",
  },
];

export const HowTo = () => (
  <section className="bg-white py-16 md:py-24" data-testid="how-to-section">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <div className="max-w-3xl">
        <h2 className="font-heading font-black text-3xl md:text-4xl tracking-tight text-zinc-900">
          Cum folosești BRD-ISIC?
        </h2>
      </div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {steps.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
            data-testid={`how-to-step-${i + 1}`}
            className="relative rounded-2xl border border-zinc-200 bg-zinc-50 p-8"
          >
            <span className="absolute top-6 right-6 font-heading font-black text-5xl text-zinc-200 select-none">
              {i + 1}
            </span>
            <div className="w-12 h-12 rounded-xl bg-brand flex items-center justify-center mb-5">
              <s.icon className="w-6 h-6 text-white" />
            </div>
            <h3 className="font-heading font-bold text-xl text-zinc-900">{s.title}</h3>
            <p className="mt-3 text-sm md:text-base text-zinc-600 leading-relaxed">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
